import { render, staticRenderFns } from "./NewInsuranceForm.vue?vue&type=template&id=161b21a4"
import script from "./NewInsuranceForm.vue?vue&type=script&lang=js"
export * from "./NewInsuranceForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports